import React from "react";

const RefreshIcon = () => {
  return <img src="./img/icon-reload-black.svg" alt="reload" className="icon-file" />;
};

export default RefreshIcon;
